import { StaticGetEndpoints } from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const PLANS_ENDPOINTS = Object.freeze({
  allENT: () => api.get(StaticGetEndpoints.AllPlansENT),
});
